import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_CPT_CODE_BY_DISCIPLINE_REQUEST,
  GET_CPT_CODE_BY_DISCIPLINE_SUCCESS,
  GET_CPT_CODE_BY_DISCIPLINE_FAILURE,
  GET_CPT_CODE_BY_DISCIPLINE_LOADER,
  GET_CPT_CODE_BY_DISCIPLINE_RESET,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isGetCptCode: false,
};

export const getCptCodeByDisciplineReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_CPT_CODE_BY_DISCIPLINE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetCptCode: true,
      };
    }

    case GET_CPT_CODE_BY_DISCIPLINE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isGetCptCode: false,
      };
    case GET_CPT_CODE_BY_DISCIPLINE_LOADER:
      return {
        ...state,
        loading: true,
      };

    case GET_CPT_CODE_BY_DISCIPLINE_RESET:
      return intitialstate;
    default:
      return state;
  }
};
